import { type EvidenceDetail, useApiEvidenceV1EvidenceSessionRetrieve } from 'api';
import { translate } from 'i18n';
import { Box, CenteredLoader, DataGrid, EvidenceImage, type GridRowSelectionModel } from 'ui';

export const EvidenceGrid = ({
  date,
  uploadedById,
  parentContentTypeId,
  parentId,
  placeholderSrc,
  setSelectedEvidenceIds,
}: {
  date: string;
  uploadedById: number | null;
  parentContentTypeId: number;
  parentId: number;
  placeholderSrc?: string;
  setSelectedEvidenceIds: (ids: number[]) => void;
}) => {
  const { data, isLoading } = useApiEvidenceV1EvidenceSessionRetrieve({
    date,
    parent_content_type_id: parentContentTypeId,
    parent_id: parentId,
    uploaded_by: uploadedById,
  });

  if (isLoading || !data) {
    return <CenteredLoader />;
  }

  return (
    <DataGrid<EvidenceDetail>
      hideFooter
      checkboxSelection
      disableColumnMenu
      onRowSelectionModelChange={(rowSelectionModel: GridRowSelectionModel) => {
        const selectedRowIds = Array.from(rowSelectionModel.ids);
        setSelectedEvidenceIds(selectedRowIds.map((id) => (typeof id === 'string' ? Number.parseInt(id, 10) : id)));
      }}
      rowHeight={250}
      rows={data.evidence_list}
      columns={[
        {
          columnSize: 'large',
          field: 'file_url',
          headerName: translate('backlog.evidenceGrid.columns.evidence', { namespace: 'features' }),
          renderCell: (params) => {
            return (
              <Box
                sx={{
                  width: '250px',
                  position: 'absolute',
                }}
              >
                <EvidenceImage src={params.value} loading="lazy" placeholderSrc={placeholderSrc} />
              </Box>
            );
          },
        },
      ]}
    />
  );
};
